// --------------------------------------------------------
// CardLineSelected - CardLineSelected
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Checkbox } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Text } from "../../../../../../components/UI/generalLayout/Layout.styled";
import Colors from "../../../../../../constants/Colors";
import { insertElementIntoList } from "../../../../../../helpers/HelperFunctions";
import {
  ContainerCardLineSelected,
  ContainerTypes,
  InputDate,
  TextArea,
} from "./CardLineSelected.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CardLineSelected INTERFACE
// --------------------------------------------------------

interface ICardLineSelected {
  exam: any;
  examList: any;
  setExamIntoList: any;
  setInvalidDate: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardLineSelected = ({ exam, examList, setExamIntoList, setInvalidDate }: ICardLineSelected) => {
  // --------------------------------------------------------
  // CardLineSelected PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [checked, setChecked] = React.useState(false);
  const [error, setError] = useState('')
  const [examResult, setExamResult] = useState<any>({dataColeta: '', unidade: '', valor: '', texto: '', formato: exam.formato })

  const { nome, formato } = exam;
  const isTextFormat = formato.toUpperCase() === 'Texto'.toUpperCase();

  const onClickCheckbox = ()=>{
    setChecked(prev => !prev); 
    setExamIntoList((prev: any)=>{
      const list = [...prev];
      const index = list.findIndex(el=>el.exameId === exam.id)
      index === -1? list.push({ exameId: exam.id, dataColeta: '', unidade: '', valor: '', texto: '', formato: exam.formato }) : list.splice(index, 1);
      return list;
    })
  } 

  const onChangeExamResultValue = (value: any)=>{
    setExamResult((prev: any)=>{ return {...prev, ...value}})
    setExamIntoList((prev: any)=>{
      let list = [...prev];
      const index = list.findIndex(el=>el.exameId === exam.id)
      const removedElement = list[index]
      const valueInsert = { ...removedElement, ...value };
      index === -1? list.push(valueInsert) :  list = [...insertElementIntoList(list, valueInsert, index)];
      return list;
    })
  }

  useEffect(()=>{
    if(examResult.dataColeta.length === 10){
      const momentDate = moment(examResult.dataColeta, 'YYYY-MM-DD');
      if(momentDate > moment()){
        setError('Data da coleta não pode ser superior à hoje!')
        setInvalidDate(true)
      }else{
        setError('')  
        setInvalidDate(false)
      }
    }
  }, [examResult])

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerCardLineSelected>
      <div style={{ flexDirection: 'row', display: 'flex' }}>
        <Checkbox onChange={onClickCheckbox} />
        <Text>{nome}</Text>
      </div>

      {checked && (
        <><Text color={Colors.error}>{error}</Text>
          {isTextFormat ? (
            <ContainerTypes>
              <Text bold>
                Data da coleta <span style={{ color: "red" }}>*</span>
              </Text>
              <InputDate type={"date"} max={moment().format('YYYY-MM-DD')} onChange={(event: any)=>{ onChangeExamResultValue({ dataColeta: event.target.value })}} />
              <ContainerTypes style={{
                marginTop: "20px"
              }}>
                <TextArea rows={8} placeholder={"Laudo textual"} onChange={(event: any)=>{ onChangeExamResultValue({ texto: event.target.value }) }}/>
              </ContainerTypes>
            </ContainerTypes>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10, marginBottom: 30 }}>
              <div>
                <Text bold>
                  Data da coleta <span style={{ color: "red" }}>*</span>
                </Text>
                <InputDate type={"date"} max={moment().format('YYYY-MM-DD')} onChange={(event: any)=>{ onChangeExamResultValue({ dataColeta: event.target.value })}} />
              </div>
              <div>
                <Text bold>
                  Valor numérico <span style={{ color: "red" }}>*</span>
                </Text>
                <InputDate type={"number"} onChange={(event: any)=>{ onChangeExamResultValue({ valor: event.target.value })}} />
              </div>
              <div>
                <Text bold>
                  Unidade de Medida <span style={{ color: "red" }}>*</span>
                </Text>
                <InputDate onChange={(event: any)=>{ onChangeExamResultValue({ unidade: event.target.value })}} />
              </div>
            </div>
          )}
        </>
      )}
    </ContainerCardLineSelected>
  );
  // --------------------------------------------------------
};

export default CardLineSelected;
